import React from 'react';
import { MapPin } from 'lucide-react';

export default function MapLegend({ totalLocations, totalStates }) {
  return (
    <div
      className="absolute bottom-4 left-4 z-[1000] bg-[#0e1416]/95 backdrop-blur-md border border-white/12 rounded-lg p-4 shadow-elev-2"
      data-testid="map-legend"
    >
      <p className="font-display-bold text-[15px] text-bone mb-3 tracking-tight" data-testid="map-legend-title">Completed Nationwide</p>
      <div className="flex items-center gap-2.5 text-sm font-semibold text-bone">
        <span className="inline-block w-3 h-3 rounded-full bg-[#3E6F86] ring-1 ring-white/40" />
        <span>Projects Completed ({totalLocations})</span>
      </div>
      <div className="mt-3 pt-3 border-t border-white/10 flex items-center gap-2 text-[11px] text-white">
        <MapPin className="w-3.5 h-3.5 text-primary" />
        <span>
          {totalLocations} projects · {totalStates} states
        </span>
      </div>
    </div>
  );
}
